module.exports = __webpack_public_path__ + "img/symbol_glaubeliebehoffnung.5fb89d7.webp";